(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-offer')) {
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        // Locale-aware: prefer Shopify's own routes root, fall back to the
        // Liquid-rendered route so the flow still works if it is unavailable.
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
        this.addUrl = root ? root + 'cart/add.js' : (this.dataset.addUrl || '/cart/add') + '.js';
        this.cartUrl = this.dataset.cartUrl || '/cart';
        this.checkoutUrl = root ? root + 'checkout' : (this.dataset.checkoutUrl || '/checkout');
        // Read-only cart snapshot for the express paths' idempotency check.
        // A plain GET on purpose: window.Velare.refreshCart() would also
        // re-render the drawer and can trigger the Ordine Prioritario
        // auto-add, which the express paths must never do.
        this.cartJsUrl = root ? root + 'cart.js' : this.cartUrl + '.js';
        this.mixMatch = !!this.querySelector('[data-mm-block]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.errorText = this.dataset.atcError || '';
        // Read with getAttribute: `data-discount-2` maps to dataset['discount-2'],
        // not dataset.discount2 — a dash before a digit is not camel-cased.
        this.discounts = {
          2: this.getAttribute('data-discount-2') || '',
          4: this.getAttribute('data-discount-4') || ''
        };
        this.defaultId = this.dataset.defaultId || '';
        this.atcLabel = this.dataset.atcLabel || 'Aggiungi al carrello';
        this.atcBusy = this.dataset.atcBusy || this.atcLabel;

        this.cards = Array.from(this.querySelectorAll('[data-offer-card]'));
        this.radios = Array.from(this.querySelectorAll('[data-offer-radio]'));
        this.atc = this.querySelector('[data-bundle-atc]');
        this.atcText = this.querySelector('[data-bundle-atc-text]');
        this.priceEls = {
          2: { total: this.querySelector('[data-price-2]') },
          4: { total: this.querySelector('[data-price-4]') }
        };

        try {
          this.prices = JSON.parse(this.querySelector('[data-bundle-prices]').textContent);
        } catch (e) {
          this.prices = {};
        }

        // The product-form above owns the swatch events and the variants JSON
        // (which carries each variant's featured media id) and the gallery
        // listens for a `gallery:select` event — reuse all three, no duplication.
        this.host = this.closest('product-form') || document;
        this.gallery = document.querySelector('[data-gallery]');
        this.media = {};
        try {
          const variantsSrc = this.host.querySelector('[data-variants]');
          if (variantsSrc) {
            JSON.parse(variantsSrc.textContent).forEach((v) => {
              this.media[String(v.id)] = v.media_id;
            });
          }
        } catch (e) {
          this.media = {};
        }

        // Offer selection + per-watch dropdown → swap the main gallery image.
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-offer-radio]')) {
            this.selectOffer(e.target.value);
          } else if (e.target.matches('[data-pick]')) {
            this.showVariantImage(e.target.value);
          }
        });

        // Keep every card's #1 dropdown in sync with the swatches above.
        this.onHostChange = (e) => {
          if (e.target && e.target.matches && e.target.matches('[data-variant-id]')) {
            this.syncPrimary(e.target.value);
          }
        };
        this.host.addEventListener('change', this.onHostChange);

        if (this.atc) this.atc.addEventListener('click', () => this.addBundle());

        // Express paths: same selection as the green button, same run(),
        // only the "after" step differs (straight to checkout instead of
        // opening the cart) — see addBundleExpress() below.
        this.paypalBtn = this.querySelector('[data-bundle-express="paypal"]');
        this.moreOptionsBtn = this.querySelector('[data-bundle-express="more"]');
        if (this.paypalBtn) this.paypalBtn.addEventListener('click', () => this.addBundleExpress(this.paypalBtn));
        if (this.moreOptionsBtn) this.moreOptionsBtn.addEventListener('click', () => this.addBundleExpress(this.moreOptionsBtn));

        const checked = this.radios.find((r) => r.checked) || this.radios[0];
        this.selectOffer(checked ? checked.value : '2');

        this.initTimer();
      }

      // Expands the selected card's rows and collapses the other one to its
      // compact head row (CSS, `.bundle-card.is-selected [data-mm-block]`).
      // The savings line and the single CTA never move — they already sit
      // below both cards — mix-match.js's own `refresh()` (also listening for
      // this same radio change) keeps them in sync with the active card.
      selectOffer(value) {
        this.offer = parseInt(value, 10) || 2;
        this.cards.forEach((card) => {
          card.classList.toggle('is-selected', card.dataset.offer === String(this.offer));
        });
      }

      cardFor(offer) {
        return this.cards.find((c) => c.dataset.offer === String(offer)) || null;
      }

      // Point the #1 dropdown of every card at a variant id (if selectable) and re-price.
      syncPrimary(id) {
        this.querySelectorAll('[data-pick="1"]').forEach((sel) => {
          const opt = Array.prototype.find.call(sel.options, (o) => o.value === String(id) && !o.disabled);
          if (opt) sel.value = String(id);
        });
        this.renderPrices(id);
      }

      renderPrices(id) {
        // In Mix & Match mode the card totals are the live payable preview,
        // owned by mix-match.js — leave them alone.
        if (this.mixMatch) return;
        const info = this.prices[id];
        if (!info) return;
        if (this.priceEls[2].total) this.priceEls[2].total.textContent = info.single;
        if (this.priceEls[4].total) this.priceEls[4].total.textContent = info.double;
      }

      // Switch the main gallery to a variant's image, exactly like the swatches
      // do — dispatch the same `gallery:select` event product.js already handles
      // (it activates the matching image + thumbnail and keeps prev/next in sync).
      showVariantImage(id) {
        const mediaId = this.media[String(id)];
        if (mediaId && this.gallery) {
          this.gallery.dispatchEvent(
            new CustomEvent('gallery:select', { detail: { mediaId: mediaId } })
          );
        }
      }

      // Merge repeats so the same variant chosen twice becomes one line of
      // quantity 2 — still a single request, never a partial bundle.
      lineItems(ids) {
        const order = [];
        const byId = {};
        ids.forEach((raw) => {
          const id = Number(raw) || raw;
          if (byId[id]) {
            byId[id].quantity += 1;
          } else {
            byId[id] = { id: id, quantity: 1 };
            order.push(byId[id]);
          }
        });
        return order;
      }

      setError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      // The pair/quad is always pre-filled and complete, so the main CTA
      // always adds every row's real variant in one request, then opens the
      // cart drawer where Shopify's real discount is visible.
      addBundle() {
        if (this.offer === 4) this.markOffer4();
        this.run(this.currentSlotIds(), () => this.openCart());
      }

      // "Paga con PayPal" and "Altre opzioni di pagamento": same selection and
      // same batch-add routine as addBundle() above, but IDEMPOTENT — they
      // ensure the active offer's variants are in the cart rather than blindly
      // adding them. Tapping the green button first and then an express button
      // used to add the whole pair/set a second time (4 watches instead of 2).
      //
      // Only ever ADDS the shortfall, never removes, so unrelated items the
      // customer already had are left alone. Still skips the cart drawer
      // entirely — no refreshCart(), no [data-cart-toggle] — which is why
      // Ordine Prioritario is still never auto-added on these paths.
      addBundleExpress(trigger) {
        if (this._busy) return;
        if (this.offer === 4) this.markOffer4();

        const ids = this.currentSlotIds();
        // Same guard run() applies, checked here so an invalid selection never
        // reaches the cart read either.
        if (!ids.length || ids.some((v) => !v)) {
          this.setError(this.errorText);
          return;
        }

        const self = this;
        this._busy = true;
        this.setError('');
        if (trigger) {
          trigger.disabled = true;
          trigger.classList.add('is-loading');
        }
        const release = () => {
          self._busy = false;
          if (trigger) {
            trigger.disabled = false;
            trigger.classList.remove('is-loading');
          }
        };

        fetch(this.cartJsUrl, { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : { items: [] }))
          // A cart we can't read is treated as empty: worst case we add the
          // set as before, which is the pre-existing behaviour.
          .catch(() => ({ items: [] }))
          .then((cart) => {
            const missing = self.missingIds(ids, cart);
            // Released and re-taken synchronously by run() in the same tick,
            // so no tap can slip in between.
            release();
            if (!missing.length) {
              // Everything already there — go straight to checkout.
              self.primeDiscount().then(() => self.goToCheckout());
              return;
            }
            self.run(missing, () => self.goToCheckout(), trigger);
          })
          .catch((err) => {
            release();
            self.setError((err && err.message) || self.errorText);
          });
      }

      // How many of each intended variant are still missing from the cart.
      // Compared by variant id and quantity, so "the pair is already there"
      // means the cart holds at least as many units of each selected variant
      // as the active offer wants. Duplicates in `ids` (e.g. the same colour
      // twice in a 2x1) are counted, not deduplicated, so a pair of identical
      // watches still requires two units present.
      missingIds(ids, cart) {
        const want = {};
        ids.forEach((raw) => {
          const k = String(raw);
          want[k] = (want[k] || 0) + 1;
        });

        const have = {};
        ((cart && cart.items) || []).forEach((item) => {
          const k = String(item.variant_id);
          have[k] = (have[k] || 0) + item.quantity;
        });

        const out = [];
        Object.keys(want).forEach((k) => {
          const deficit = want[k] - (have[k] || 0);
          for (let i = 0; i < deficit; i++) out.push(k);
        });
        return out;
      }

      goToCheckout() {
        window.location.href = this.checkoutUrl;
      }

      // Filled, visible slot ids of a container, in slot order. Empty and hidden
      // (clamped) slots are excluded.
      filledSlotIds(container) {
        return Array.from(container.querySelectorAll('[data-mm-slot]'))
          .filter((s) => !s.hasAttribute('hidden') && s.getAttribute('data-selected-id'))
          .sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index))
          .map((s) => s.getAttribute('data-selected-id'));
      }

      currentSlotIds() {
        const card = this.cardFor(this.offer);
        const ids = card ? this.filledSlotIds(card) : [];
        return ids.length ? ids : [this.defaultId];
      }

      // Remember the customer is assembling a 4x2 so the catalogue and other
      // product pages show the completing state (isolated from the 2x1 state).
      markOffer4() {
        try { sessionStorage.setItem('velareBundleOffer', '4'); } catch (e) {}
      }

      // Single add pipeline for the main CTA.
      run(ids, after, trigger) {
        if (this._busy) return;
        // Empty slots never proceed; the selection is left untouched.
        if (!ids.length || ids.some((v) => !v)) {
          this.setError(this.errorText);
          return;
        }

        this._busy = true;
        this.setError('');
        const busyEl = trigger || this.atc;
        if (busyEl) {
          busyEl.disabled = true;
          busyEl.classList.add('is-loading');
        }
        if (!trigger && this.atcText) this.atcText.textContent = this.atcBusy;

        fetch(this.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: this.lineItems(ids) })
        })
          .then((r) => r.json().then((data) => {
            // Shopify answers 422 with a human description when a variant ran
            // out between rendering and adding — surface it, add nothing.
            if (!r.ok) throw new Error(data.description || data.message || '');
            return data;
          }))
          // Best-effort: pre-apply the real discount for the selected offer.
          // Shopify stores it on the session, so it survives the catalogue trip.
          .then(() => this.primeDiscount())
          .then(after)
          .catch((err) => {
            this.setError((err && err.message) || this.errorText);
          })
          .finally(() => {
            this._busy = false;
            if (busyEl) {
              busyEl.disabled = false;
              busyEl.classList.remove('is-loading');
            }
            // The label is live: mix-match.js swaps it with the cart state.
            if (this.atcText) this.atcText.textContent = this.currentLabel();
          });
      }

      discountCode() {
        return this.discounts[this.offer] || '';
      }

      primeDiscount() {
        const code = this.discountCode();
        if (!code) return Promise.resolve();
        return fetch('/discount/' + encodeURIComponent(code), {
          headers: { Accept: 'text/html' }
        }).catch(function () {});
      }

      currentLabel() {
        return this.getAttribute('data-atc-label') || this.atcLabel;
      }

      openCart() {
        const toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) {
          toggle.click();
        } else {
          window.location.href = this.cartUrl;
        }
      }

      /* ---- Urgency timer (never blocks purchase) ----
         Reads the ONE shared promo countdown (assets/countdown.js,
         window.Velare.promoCountdown) — the same source the announcement bar
         uses — so the two can never show different remaining times. It owns
         the duration, the persisted start and the rollover; this only formats.
         The old private 15-minute sessionStorage timer is gone.
         `data-timer-enabled` still decides whether this badge shows at all. */
      initTimer() {
        if (this.dataset.timerEnabled !== 'true') return;
        this.clockEl = this.querySelector('[data-bundle-clock]');
        if (!this.clockEl) return;

        // Subscribe to the shared tick so this badge repaints on the very same
        // beat, from the very same value, as the announcement bar. countdown.js
        // is a separate deferred script, so it may not have run yet — retry
        // briefly rather than fall back to a second, divergent timer.
        const attach = () => {
          const shared = window.Velare && window.Velare.promoCountdown;
          if (!shared) return false;
          const pad = shared.pad;
          this._unsubTimer = shared.subscribe((ms) => {
            const t = shared.parts(ms);
            this.clockEl.textContent = pad(t.hours) + ':' + pad(t.minutes) + ':' + pad(t.seconds);
          });
          return true;
        };
        if (!attach()) {
          const wait = setInterval(() => { if (attach()) clearInterval(wait); }, 100);
        }
      }
    }

    customElements.define('bundle-offer', BundleOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-form')) {
    // Reuse the SAME variant->image URL the colour swatches already carry
    // (option[data-image], rendered at width:100 for the little thumbnail) but
    // request a card-sized version for the main image — just swap the ?width=
    // param (or append it). No second image map is introduced.
    function upsizeCardImage(url, width) {
      if (!url) return url;
      if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + width);
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    /*
     * One card = one watch per click, state aware.
     *
     * `velare:cart` is published by cart-drawer.js and carries the eligible
     * watch quantity in the cart (line-item quantities, protection add-on
     * excluded). An odd quantity means a 2x1 pair is half-open, so this card
     * completes it; an even quantity means this card starts a new one.
     *
     * A 4x2 journey is signalled by the `velareBundleOffer` session marker
     * (set on the product page). While it is active the card instead offers to
     * add the watch as the 2nd / 3rd / 4th of the 4x2. The two states are
     * isolated: the 4x2 marker never affects the 2x1 labelling, and vice versa.
     *
     * Mix & Match swap: when assets/mix-match.js opens the guided modal to
     * replace the free watch in an already-complete cart, it sets
     * `window.Velare.mixMatchSwap = { key, nextQuantity }` first. This card
     * checks that flag at click time (see runSwap()) and, if set, adds the
     * new variant then reduces the replaced line instead of the normal
     * single-add flow — the only place this component's add behaviour
     * changes.
     *
     * Pair model (site grids only — never a Mix & Match card, see
     * snippets/product-card.liquid's `mix_match` doc): when the card renders
     * TWO `[data-card-variant]` selects instead of one, this becomes a
     * batch add instead of a single add — see addPair(), the single place
     * this component's OTHER add behaviour changes. Pair cards never read or
     * write window.Velare.mixMatchSwap, the pending/quad cart state, or
     * anything else shared — each <product-card-form> instance owns only
     * its own DOM, so multiple pair cards on one page never bleed state.
     */
    class ProductCardForm extends HTMLElement {
      connectedCallback() {
        this.addUrl = (this.dataset.addUrl || '/cart/add') + '.js';
        this.changeUrl = (this.dataset.changeUrl || '/cart/change') + '.js';
        this.cartUrl = this.dataset.cartUrl || '/cart';
        this.button = this.querySelector('[data-card-atc]');
        this.selects = Array.prototype.slice.call(this.querySelectorAll('[data-card-variant]'));
        this.select = this.selects[0] || null;
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-card-color-thumb]'));
        this.selectLabels = Array.prototype.slice.call(this.querySelectorAll('[data-card-select-label]'));
        this.msg = this.querySelector('[data-card-msg]');
        this.pending = false;
        this.quad = false;
        this.quadInCart = 0;

        if (this.button) this.button.addEventListener('click', this.onAdd.bind(this));

        if (this.selects.length > 1) {
          // Pair mode: each row only ever swaps its OWN small thumbnail —
          // the card's main photo and price stay put, since there is no
          // longer a single "the" selected variant to preview.
          this.selects.forEach(function (select, index) {
            select.addEventListener('change', this.onPairVariantChange.bind(this, select, index));
          }, this);
        } else if (this.select) {
          this.select.addEventListener('change', this.onVariant.bind(this));
        }

        this.onState = this.onState.bind(this);
        document.addEventListener('velare:cart', this.onState);
        if (window.Velare && window.Velare.bundleState) {
          this.applyState(window.Velare.bundleState);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('velare:cart', this.onState);
      }

      /* ---- Variant selection ---- */
      onVariant() {
        var opt = this.select.options[this.select.selectedIndex];
        if (!opt) return;

        var card = this.closest('.product-card');
        var image = card ? card.querySelector('.product-card__image--primary') : null;
        var src = opt.getAttribute('data-image');
        if (image && src) {
          image.setAttribute('src', src);
          // A single explicit src must win over the responsive set.
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }

        var price = card ? card.querySelector('[data-price-current]') : null;
        var money = opt.getAttribute('data-price');
        if (price && money) price.textContent = money;

        var available = opt.getAttribute('data-available') !== 'false';
        if (this.button) this.button.disabled = !available;
      }

      // Pair mode: every option here is already a real, available variant
      // (sold-out ones are excluded outright when the card is built), so unlike
      // onVariant() there is no availability/button-state to toggle. Updates
      // this row's own thumbnail + label, AND the card's main image.
      onPairVariantChange(select, index) {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var src = opt.getAttribute('data-image');

        // This row's small swatch thumbnail (100px data-image is the right size).
        var thumb = this.thumbs[index];
        if (thumb && src) thumb.setAttribute('src', src);

        var label = this.selectLabels[index];
        if (label) label.textContent = opt.textContent;

        // Main card image follows the LAST dropdown touched (the same
        // "last interaction wins" rule the product-page gallery uses): swap it
        // to a card-sized version of THIS variant's image, reusing the very
        // same data-image the swatch carries (just a larger ?width). A variant
        // with no image (empty data-image) keeps the current image — never
        // blanked. Scoped to this.closest('.product-card'), so one card never
        // touches another. Non-blocking: the browser loads the new src in the
        // background and keeps showing the current image until it's ready.
        if (src) {
          var card = this.closest('.product-card');
          var image = card ? card.querySelector('.product-card__image--primary') : null;
          if (image) {
            image.setAttribute('src', upsizeCardImage(src, 600));
            // A single explicit src must win over the responsive set.
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
          }
        }
      }

      variantId() {
        if (this.select && this.select.value) return this.select.value;
        return this.dataset.defaultId || '';
      }

      /* ---- Cart state ---- */
      onState(e) {
        this.applyState(e.detail);
      }

      quadMarker() {
        try { return sessionStorage.getItem('velareBundleOffer') || ''; } catch (e) { return ''; }
      }

      applyState(detail) {
        // Pair cards always show the plain, static "Aggiungi al carrello" —
        // they add a self-contained pair on their own, so the site-wide
        // pending/quad progress (which is about the Mix & Match cards
        // completing THAT bundle) has nothing to say about this button.
        if (this.selects.length > 1) return;

        // Cards inside the cart's Mix & Match carousel have their button label
        // owned by the carousel itself (assets/mix-match.js carouselButtonLabel
        // = "Aggiungi"); the site-wide progress copy must not fight it — the
        // relocation between the drawer's two slots reconnects these elements
        // and would otherwise let this run last and clobber the label. Their
        // add is always an in-place add (finishes=false via the initial
        // pending/quad=false), so there is nothing else here they need.
        if (this.closest('[data-mm-carousel]')) return;

        this.pending = !!(detail && detail.pending);
        var wc = detail && detail.watchCount ? detail.watchCount : 0;

        // The 4x2 completing state only applies during an active 4x2 journey
        // with a partial group in the cart. A clean multiple of four clears it.
        var marker = this.quadMarker();
        if (wc % 4 === 0 && marker) {
          try { sessionStorage.removeItem('velareBundleOffer'); } catch (e) {}
          marker = '';
        }
        this.quad = marker === '4' && wc % 4 !== 0;
        this.quadInCart = this.quad ? wc % 4 : 0;

        if (!this.button) return;
        var label;
        if (this.quad) {
          // Add as the 2nd / 3rd / 4th watch of the 4x2.
          label = this.button.getAttribute('data-label-4-' + (this.quadInCart + 1));
        } else {
          label = this.pending
            ? this.button.getAttribute('data-label-second')
            : this.button.getAttribute('data-label-first');
        }
        if (label) this.button.textContent = label;
      }

      /* ---- Add ---- */
      onAdd() {
        if (this._busy) return;

        if (this.selects.length > 1) {
          this.addPair();
          return;
        }

        var id = this.variantId();
        if (!id) return;

        this._busy = true;
        this.button.disabled = true;
        this.button.classList.add('is-loading');
        if (this.msg) this.msg.hidden = true;

        var self = this;

        // Mix & Match swap: the carousel and the full "Vedi tutti i modelli"
        // picker both arm window.Velare.mixMatchSwap fresh, in a capture-phase
        // listener on their own container, in the instant just before this
        // click handler runs (assets/mix-match.js) — never computed once and
        // held while the picker sits open, so it can't go stale. Read and
        // cleared here, synchronously, so a second card clicked in the same
        // instant can never also see it and trigger a duplicate swap.
        var swap = window.Velare && window.Velare.mixMatchSwap;
        if (swap) window.Velare.mixMatchSwap = null;

        if (swap && String(swap.variantId) === String(id)) {
          // Re-picking the exact watch being replaced is a no-op — adding one
          // unit and immediately removing it again would net to nothing, so
          // just close the picker instead.
          this._busy = false;
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
          if (window.Velare && window.Velare.closeMixMatchPicker) window.Velare.closeMixMatchPicker();
          return;
        }

        if (swap) {
          this.runSwap(id, swap);
          return;
        }

        // Does this single add finish the active bundle?
        // 2x1: an odd cart means this completes the pair.
        // 4x2: adding this watch reaches the fourth of the group.
        var quad = this.quad;
        var finishes = quad ? this.quadInCart + 1 >= 4 : this.pending;

        fetch(this.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id) || id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            // Finishing the bundle opens the drawer so Shopify's real discount
            // is visible; otherwise keep the customer in the catalogue to pick
            // the next watch, and only re-sync the shared cart state.
            if (finishes) {
              self.openCart();
              return;
            }
            self.confirm(quad);
            if (window.Velare && window.Velare.refreshCart) {
              window.Velare.refreshCart().catch(function () {});
            }
          })
          .catch(function () { window.location.href = self.cartUrl; })
          .finally(function () {
            self._busy = false;
            self.button.disabled = false;
            self.button.classList.remove('is-loading');
          });
      }

      // Pair mode: both selected variants in ONE Ajax request — the exact
      // same shape as the product page's own pair/quad add
      // (snippets/product-bundle-offer.liquid's run()/lineItems()): one POST
      // to /cart/add.js, one items array, duplicate ids merged into a single
      // {id, quantity} line rather than sent as two separate entries. That
      // logic is private to <bundle-offer> and isn't exported anywhere this
      // component could call into directly, so the same merge rule and the
      // same fetch shape are replicated here rather than duplicating a
      // second, DIFFERENT batch-add design. Opens the cart the same way this
      // class's own single-add "finishes" branch already does, above.
      addPair() {
        var ids = this.selects.map(function (s) { return s.value; }).filter(Boolean);
        if (ids.length < 2) return;

        this._busy = true;
        this.button.disabled = true;
        this.button.classList.add('is-loading');

        var order = [];
        var byId = {};
        ids.forEach(function (raw) {
          var id = Number(raw) || raw;
          if (byId[id]) {
            byId[id].quantity += 1;
          } else {
            byId[id] = { id: id, quantity: 1 };
            order.push(byId[id]);
          }
        });

        var self = this;
        fetch(this.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: order })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            self.openCart();
          })
          .catch(function () { window.location.href = self.cartUrl; })
          .finally(function () {
            self._busy = false;
            self.button.disabled = false;
            self.button.classList.remove('is-loading');
          });
      }

      // Add the newly chosen variant first, then remove the watch it
      // replaces (down to `swap.nextQuantity`, which is 0 for a dedicated
      // free line or one less on a merged same-colour line) — in that order,
      // so the cart is never briefly short a watch. One Ajax flow; Shopify
      // reallocates the real discount once both requests land.
      runSwap(id, swap) {
        var self = this;

        var addStep = function () {
          return fetch(self.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id) || id, quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          });
        };

        var changeStep = function () {
          return fetch(self.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: swap.key, quantity: swap.nextQuantity })
          }).then(function (r) {
            if (!r.ok) throw new Error('swap failed');
            return r.json();
          });
        };

        // Default (every 2x1 path): add first, so the cart is never briefly
        // short a watch — unchanged.
        //
        // `changeFirst` is set only by the 4x2 per-line swap. There the add
        // has to come SECOND: pushing the cart to five units makes Shopify
        // re-allocate the discount, which can split a merged "x2" line into
        // two lines with brand-new keys — invalidating swap.key before the
        // decrement lands, so the change would silently no-op and leave five
        // watches in the cart. Decrementing first uses a key that is still
        // valid, and the whole thing is still one Ajax flow.
        var flow = swap.changeFirst ? changeStep().then(addStep) : addStep().then(changeStep);

        flow
          .then(function () {
            if (window.Velare && window.Velare.closeMixMatchPicker) window.Velare.closeMixMatchPicker();
            if (window.Velare && window.Velare.refreshCart) {
              return window.Velare.refreshCart().then(function () { self.openCart(); });
            }
            self.openCart();
          })
          .catch(function () { window.location.href = self.cartUrl; })
          .finally(function () {
            self._busy = false;
            self.button.disabled = false;
            self.button.classList.remove('is-loading');
          });
      }

      confirm(is4x2) {
        if (!this.msg) return;
        var text = is4x2
          ? this.msg.getAttribute('data-msg-4')
          : this.msg.getAttribute('data-msg-default');
        if (text) this.msg.textContent = text;
        this.msg.hidden = false;
        clearTimeout(this._msgTimer);
        var el = this.msg;
        this._msgTimer = setTimeout(function () { el.hidden = true; }, 6000);
      }

      openCart() {
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) {
          toggle.click();
        } else {
          window.location.href = this.cartUrl;
        }
      }
    }

    customElements.define('product-card-form', ProductCardForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-offer-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('offer-tiers')) {
    class OfferTiers extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.idInput = this.querySelector('[data-offer-id-input]');
        this.atc = this.querySelector('[data-offer-atc]');
        this.atcText = this.querySelector('[data-offer-atc-text]');
        this.cards = Array.from(this.querySelectorAll('[data-tier-card]'));
        this.tierRadios = Array.from(this.querySelectorAll('[data-tier-radio]'));

        this.props = {
          1: this.querySelector('[data-offer-prop="1"]'),
          2: this.querySelector('[data-offer-prop="2"]'),
          3: this.querySelector('[data-offer-prop="3"]')
        };
        this.watchGroups = {
          1: this.querySelector('[data-watch="1"]'),
          2: this.querySelector('[data-watch="2"]'),
          3: this.querySelector('[data-watch="3"]')
        };
        this.selectedLabels = {
          1: this.querySelector('[data-watch-selected="1"]'),
          2: this.querySelector('[data-watch-selected="2"]'),
          3: this.querySelector('[data-watch-selected="3"]')
        };

        this.b2Id = this.dataset.b2Id || '';
        this.b3Id = this.dataset.b3Id || '';
        this.singleId = this.dataset.singleId || '';
        this.hasColors = this.dataset.hasColors === 'true';
        this.hasB3 = !!this.b3Id;
        this.addLabel = this.dataset.addLabel || 'Aggiungi al carrello';
        this.soldLabel = this.dataset.soldoutLabel || 'Esaurito';

        // Tier selection
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-tier-radio]')) {
            this.applyTier(e.target.value);
          } else if (e.target.matches('[data-swatch]')) {
            this.onSwatch(e.target);
          }
        });

        // Default tier (middle) selected on load.
        let start = this.dataset.defaultTier || '2';
        if (start === '3' && !this.hasB3) start = '2';
        const startRadio = this.tierRadios.find((r) => r.value === start) || this.tierRadios[0];
        if (startRadio) startRadio.checked = true;
        this.applyTier(startRadio ? startRadio.value : '1');

        this.initTimer();
      }

      // Return the checked swatch of a given watch group (1..3).
      selected(watch) {
        const g = this.watchGroups[watch];
        if (!g) return null;
        return g.querySelector('input[data-swatch]:checked') || g.querySelector('input[data-swatch]:not([disabled])');
      }

      onSwatch(input) {
        const w = input.dataset.watchIndex;
        if (this.selectedLabels[w]) this.selectedLabels[w].textContent = input.dataset.color || '';
        // Only watch 1 drives the main gallery / form id for tier 1.
        if (w === '1') this.syncTier();
      }

      applyTier(tier) {
        this.tier = tier;
        const t = parseInt(tier, 10) || 1;

        // Show/hide the right number of color pickers.
        [1, 2, 3].forEach((n) => {
          const g = this.watchGroups[n];
          if (!g) return;
          g.hidden = n > t;
        });

        this.syncTier();
      }

      // Set the form's line item (id + properties) to match the selected tier.
      syncTier() {
        const t = parseInt(this.tier, 10) || 1;
        let available = true;

        if (t === 1) {
          const w1 = this.selected(1);
          const id = w1 ? w1.value : this.singleId;
          if (this.idInput) this.idInput.value = id;
          if (w1) available = w1.dataset.available === 'true';
          this.setProp(1, null);
          this.setProp(2, null);
          this.setProp(3, null);
        } else if (t === 2) {
          if (this.idInput) this.idInput.value = this.b2Id;
          available = this.dataset.b2Available !== 'false';
          this.setProp(1, this.colorOf(1));
          this.setProp(2, this.colorOf(2));
          this.setProp(3, null);
        } else {
          if (this.idInput) this.idInput.value = this.b3Id;
          available = this.dataset.b3Available !== 'false';
          this.setProp(1, this.colorOf(1));
          this.setProp(2, this.colorOf(2));
          this.setProp(3, this.colorOf(3));
        }

        if (this.atc) {
          this.atc.disabled = !available;
          if (this.atcText) this.atcText.textContent = available ? this.addLabel : this.soldLabel;
        }
      }

      colorOf(watch) {
        if (!this.hasColors) return null;
        const s = this.selected(watch);
        return s ? s.dataset.color : null;
      }

      // Enable + fill a property input, or disable it so it drops out of FormData.
      setProp(n, value) {
        const el = this.props[n];
        if (!el) return;
        if (value == null || value === '') {
          el.disabled = true;
          el.value = '';
        } else {
          el.disabled = false;
          el.value = value;
        }
      }

      /* ---- Per-session urgency timer (never blocks purchase) ---- */
      initTimer() {
        if (this.dataset.timerEnabled !== 'true') return;
        this.timerEl = this.querySelector('[data-offer-timer]');
        this.clockEl = this.querySelector('[data-offer-clock]');
        if (!this.timerEl || !this.clockEl) return;

        this.timerEl.hidden = false;

        /* Same single shared promo countdown the announcement bar and the
           bundle offer badge read (assets/countdown.js). This buy box is the
           alternative to the bundle one, so it carried an identical private
           15-minute timer — repointed here too, otherwise it would still
           contradict the bar whenever a merchant switches to it. Only the
           formatting (total minutes : seconds) is local. */
        const attach = () => {
          const shared = window.Velare && window.Velare.promoCountdown;
          if (!shared) return false;
          const pad = shared.pad;
          this._unsubTimer = shared.subscribe((ms) => {
            this.clockEl.textContent = pad(Math.floor(ms / 60000)) + ':' + pad(Math.floor((ms % 60000) / 1000));
          });
          return true;
        };
        if (!attach()) {
          const wait = setInterval(() => { if (attach()) clearInterval(wait); }, 100);
        }
      }
    }

    customElements.define('offer-tiers', OfferTiers);
  }
  } catch(e) { console.error(e); }
})();

})();
